import moment from "moment-timezone";
import { defaultColor } from "../constants/DefaultColor";

export const addToAp = (tournamentId) => {
  return new Promise((resolve) => {
    const db = window.firebase.firestore();
    let batch = db.batch();
    db.collection("tournaments")
      .doc(tournamentId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let tournament = doc.data();
          let record = {
            name: tournament.name || "",
            date: tournament.date || "",
            bgURL: tournament.bgURL || "",
            logoURL: tournament.logoURL || "",
            addedOn: window.firebase.firestore.FieldValue.serverTimestamp(),
            color: tournament.color || defaultColor,
          };
          let keywords = [];
          for (let x = 0; x < (tournament.name || "").length; x++) {
            let name = tournament.name.slice(x);
            for (let y = 0; y < name.length; y++) {
              let namePart = name.slice(0, y + 1);
              if (namePart.length > 0) {
                keywords.push(namePart.toLowerCase());
              }
            }
          }
          record["keywords"] = keywords;
          let newDoc = db.collection("tournamentSearch").doc(tournamentId);
          batch.set(newDoc, record);

          db.collection("tournaments")
            .doc(tournamentId)
            .collection("days")
            .get()
            .then((daysSnap) => {
              let daysByKey = {};
              daysSnap.forEach((daySnap) => {
                daysByKey[daySnap.id] = daySnap.data();
              });
              Object.keys(tournament.fields || {}).forEach((fieldKey) => {
                batch.set(db.collection("cacheUpdatesForField").doc(), {
                  tournamentId: tournamentId,
                  fieldId: fieldKey,
                  status: "pending",
                  timestamp:
                    window.firebase.firestore.FieldValue.serverTimestamp(),
                });
              });

              let minutes = 0;
              if (tournament.nH !== undefined) {
                minutes = tournament.nH * 60;
              }
              if (tournament.nM !== undefined) {
                minutes += tournament.nM;
              }
              if (tournament.nH === undefined && tournament.nM === undefined) {
                minutes = 15;
              }

              Object.keys(tournament.roundTimes || {}).forEach((key) => {
                let roundTime = tournament.roundTimes[key];
                if (roundTime.time) {
                  const roundNotificationsRef =
                    db.collection("roundNotifications");

                  let dateString = moment
                    .unix(
                      roundTime.day !== "0"
                        ? (daysByKey[roundTime.day] || {}).date ||
                            tournament.date
                        : tournament.date
                    )
                    .tz(tournament.timezone || "Europe/Amsterdam")
                    .format("YYYY-MM-DD");

                  batch.set(roundNotificationsRef.doc(tournamentId + key), {
                    startTimeStamp: moment
                      .tz(
                        dateString + " " + roundTime.time,
                        "YYYY-MM-DD HH:mm",
                        tournament.timezone || "Europe/Amsterdam"
                      )
                      .unix(),
                    sendTimeStamp: moment
                      .tz(
                        dateString + " " + roundTime.time,
                        "YYYY-MM-DD HH:mm",
                        tournament.timezone || "Europe/Amsterdam"
                      )
                      .subtract(minutes, "m")
                      .unix(),
                    st: roundTime.time,
                    et: "",
                    tournamentId: tournamentId,
                    sent: false,
                    roundNum: Number(key),
                  });
                }
              });

              batch.set(db.collection("cacheUpdatesApp").doc(), {
                tournamentId: tournamentId,
                status: "pending",
                timestamp:
                  window.firebase.firestore.FieldValue.serverTimestamp(),
              });

              batch.update(db.collection("tournaments").doc(tournamentId), {
                ia: true,
              });

              batch.commit().then(() => {
                resolve();
              });
            });
        }
      });
  });
};
